import { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { clients } from "@/mocks/clients";

export default function LiveFeed() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState<typeof clients[0] | null>(null);
  const [show, setShow] = useState(false);
  const [idx, setIdx] = useState(0);

  const showNext = useCallback(() => {
    setShow(false);
    setTimeout(() => {
      setVisible(clients[idx % clients.length]);
      setIdx((p) => p + 1);
      setShow(true);
    }, 400);
  }, [idx]);

  useEffect(() => {
    showNext();
    const interval = setInterval(showNext, 5000);
    return () => clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!visible) return null;

  const profit = Math.round(visible.amount * visible.yield / 100);

  return (
    <div
      className={`fixed bottom-4 left-3 md:bottom-6 md:left-6 z-50 w-[calc(100vw-24px)] max-w-[280px] md:max-w-xs transition-all duration-500 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
      }`}
    >
      <div className="bg-[#0a0f1e]/95 backdrop-blur-md border border-emerald-400/30 rounded-lg p-3 md:p-4 flex items-start gap-2 md:gap-3">
        {/* Pulse dot */}
        <div className="flex-shrink-0 mt-0.5">
          <span className="relative flex h-2.5 w-2.5 md:h-3 md:w-3">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 md:h-3 md:w-3 bg-emerald-400" />
          </span>
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1 md:gap-1.5 mb-0.5 md:mb-1">
            <span className="text-sm md:text-base leading-none">{visible.flag}</span>
            <span className="text-white font-bold text-[10px] md:text-xs truncate" style={{ fontFamily: "'Orbitron', sans-serif" }}>
              {visible.name}
            </span>
          </div>
          <p className="text-white/50 text-[10px] md:text-xs leading-relaxed">
            <span className="text-white/70">{visible.country}</span> {t("livefeed_received")}
          </p>
          <div className="flex items-center gap-1.5 md:gap-2 mt-1 md:mt-1.5">
            <span className="text-emerald-400 font-black text-xs md:text-sm" style={{ fontFamily: "'Orbitron', sans-serif" }}>
              +{profit.toLocaleString()} EUR
            </span>
            <span className="text-white/20 text-xs">·</span>
            <span className="text-amber-400 text-[10px] md:text-xs">+{visible.yield}%</span>
          </div>
          <div className="text-white/20 text-[9px] md:text-xs mt-0.5 md:mt-1">{visible.timeAgo}</div>
        </div>
      </div>
    </div>
  );
}
